import {
  AeoOnboardingRunSchema,
  AeoOnboardingStepSchema,
} from "@redotech/redo-model/aeo/onboarding";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAeoOnboardingState = unaryRpc({
  name: "getAeoOnboardingState",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    run: AeoOnboardingRunSchema.nullable(),
    steps: z.array(AeoOnboardingStepSchema),
    progress: z.object({
      completedCount: z.number(),
      totalCount: z.number(),
      percentage: z.number(),
    }),
    canStart: z.boolean(),
    canCancel: z.boolean(),
    canRetry: z.boolean(),
  }),
});
